import warehouse from './warehouse';
import item from './item';
import itemType from './itemType';
import uom from './uom';
import itemMeasureUnit from './itemMeasureUnit';
import auth from './auth';
import receiveNote from './receiveNote';
import issueVoucher from './issueVoucher'
import itemTypeGroup from './itemTypeGroup';
import itemTypeGroupClass from './itemTypeGroupClass';
import stockAdjustment from './stockAdjustment';
import reason from './reason';
import ledgerSetting from './ledgerSetting';
import measureUnit from './measureUnit';
export default {
    namespaced: true,
    state: {
        routePrefix: '/stock'
    },
    mutations: {},
    actions: {},
    modules: {
        warehouse,
        item,
        itemType,
        uom,
        itemMeasureUnit,
        auth,
        receiveNote,
        issueVoucher,
        itemTypeGroup,
        itemTypeGroupClass,
        stockAdjustment,
        reason,
        ledgerSetting,
        measureUnit
    }
}